module.exports = __webpack_public_path__ + "static/media/ipad_comp_light.80ede1a4.svg";